import React from 'react'

const PageNotFound = () => {
  return (
    <div>
        <h1>-- 404 --</h1>
        <h2>Page Not Found</h2>
    </div>
  )
}

export default PageNotFound